//

const Dashboard = ({ userToken }) => {
  return <></>;
  // let slides = [
  //   {
  //     image: "/assets/images/icons/community(2).png",
  //     content: "1111111111111111111",
  //   },
  //   {
  //     image: "/assets/images/icons/community(2).png",
  //     content:
  //       "22222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222",
  //   },
  // ];
  // const changeElementActiveClass = (element) => {
  //   let elements = document.querySelectorAll(".sliderItem");
  //   for (let i = 0; i < elements.length; i++) {
  //     elements[i].classList.remove("workGroupsActiveClass");
  //   }
  //   element.currentTarget.classList.add("workGroupsActiveClass");
  // };
  // const onRightClickHandler = (e) => {
  //   e.stopPropagation();
  //   if (getDir(getCurrentLangFromRedux()) === "ltr") {
  //     if (currentPage < slides.length - 2) {
  //       setCurrentPage(() => currentPage + 1);
  //     } else {
  //       setCurrentPage(0);
  //     }
  //   } else {
  //     if (currentPage <= 0) {
  //       setCurrentPage(() => slides.length - 2);
  //     } else if (currentPage) {
  //       setCurrentPage(() => currentPage - 1);
  //     }
  //   }
  //   // setCurrentPage(counter + 1);
  // };
  // const onLeftClickHandler = (e) => {
  //   e.stopPropagation();
  //   if (getDir(getCurrentLangFromRedux()) === "ltr") {
  //     if (currentPage <= 0) {
  //       setCurrentPage(() => slides.length - 2);
  //     } else if (currentPage) {
  //       setCurrentPage(() => currentPage - 1);
  //     }
  //   } else {
  //     if (currentPage < slides.length - 2) {
  //       setCurrentPage(() => currentPage + 1);
  //     } else {
  //       setCurrentPage(0);
  //     }
  //   }
  // };
  // // small to mid screens
  // const onSmallRightClickHandler = (e) => {
  //   e.stopPropagation();
  //   if (getDir(getCurrentLangFromRedux()) === "ltr") {
  //     if (currentPage < slides.length - 1) {
  //       setCurrentPage(() => currentPage + 1);
  //     } else {
  //       setCurrentPage(0);
  //     }
  //   } else {
  //     if (currentPage <= 0) {
  //       setCurrentPage(() => slides.length - 1);
  //     } else if (currentPage) {
  //       setCurrentPage(() => currentPage - 1);
  //     }
  //   }
  // };
  // const onSmallLeftClickHandler = (e) => {
  //   e.stopPropagation();
  //   if (getDir(getCurrentLangFromRedux()) === "ltr") {
  //     if (currentPage <= 0) {
  //       setCurrentPage(() => slides.length - 1);
  //     } else if (currentPage) {
  //       setCurrentPage(() => currentPage - 1);
  //     }
  //   } else {
  //     if (currentPage < slides.length - 1) {
  //       setCurrentPage(() => currentPage + 1);
  //     } else {
  //       setCurrentPage(0);
  //     }
  //   }
  // };
  // return (
  //   <>
  //     <p className="m-0 p-2">مجموعات العمل</p>
  //     <div className="d-md-flex d-none pt-2 pb-3">
  //       {slides.map((item, index) => {
  //         return (
  //           <div
  //             className="d-flex flex-row align-items-center mx-3 py-3 sliderItem"
  //             style={{
  //               border: "1px solid #1A73E8",
  //               borderRadius: 10,
  //               width: "35%",
  //               height: 100,
  //               overflow: "auto",
  //             }}
  //             onClick={(e) => {
  //               // dispatch(currentCommunity(5));
  //               // CLICKHERE
  //               changeElementActiveClass(e);
  //             }}
  //           >
  //             <div className="px-2">
  //               <svg
  //                 xmlns="http://www.w3.org/2000/svg"
  //                 width="32"
  //                 height="32"
  //                 viewBox="0 0 32 32"
  //               >
  //                 <path
  //                   id="networking_1_"
  //                   data-name="networking (1)"
  //                   d="M25.6,12.8a6.4,6.4,0,1,0-5.793-9.1l-1.714-.633a2.589,2.589,0,0,0,.041-.4,2.69,2.69,0,1,0-.408,1.4l1.711.632a6.283,6.283,0,0,0,.087,3.7l-5.866,2.486a6.369,6.369,0,0,0-7.915-3l-1.475-3.1a2.653,2.653,0,1,0-1.6.549,2.622,2.622,0,0,0,.641-.087l1.473,3.1A6.389,6.389,0,0,0,4.44,19.181l-.976,1.754a2.639,2.639,0,0,0-.8-.135,2.7,2.7,0,1,0,1.73.654L5.374,19.7a6.346,6.346,0,0,0,6.515-.759l2.1,2.309A6.369,6.369,0,0,0,12.267,25.6a6.441,6.441,0,0,0,.079.957l-2.47.586a2.651,2.651,0,1,0,.257,1.123c0-.029-.008-.057-.009-.086L12.59,27.6A6.4,6.4,0,1,0,24.3,22.574l3.133-2.037a2.719,2.719,0,1,0-.579-.9l-3.14,2.041a6.436,6.436,0,0,0-2.384-1.893l2.6-7.216A6.377,6.377,0,0,0,25.6,12.8ZM15.467,4.267a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,15.467,4.267Zm-14.4-1.6a1.6,1.6,0,1,1,1.6,1.6A1.6,1.6,0,0,1,1.067,2.667Zm1.6,22.4a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,2.667,25.067Zm4.8,4.8a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,7.467,29.867Zm21.867-12.8a1.6,1.6,0,1,1-1.6,1.6A1.6,1.6,0,0,1,29.333,17.067ZM22.459,10.7a2.674,2.674,0,0,1,2.608-2.167h1.067A2.674,2.674,0,0,1,28.741,10.7a5.293,5.293,0,0,1-6.282,0ZM25.6,7.467a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,25.6,7.467Zm0-6.4a5.325,5.325,0,0,1,4.026,8.821A3.778,3.778,0,0,0,27.5,7.73a2.667,2.667,0,1,0-3.8,0,3.778,3.778,0,0,0-2.124,2.157A5.325,5.325,0,0,1,25.6,1.067ZM2.667,13.867a5.333,5.333,0,1,1,9.352,3.5A3.779,3.779,0,0,0,9.892,15.2a2.667,2.667,0,1,0-3.8,0,3.777,3.777,0,0,0-2.121,2.149A5.3,5.3,0,0,1,2.667,13.867Zm3.723-.533a1.6,1.6,0,1,1,1.6,1.6A1.6,1.6,0,0,1,6.389,13.333ZM4.85,18.16A2.674,2.674,0,0,1,7.456,16H8.523a2.673,2.673,0,0,1,2.609,2.174A5.292,5.292,0,0,1,4.85,18.16ZM15.517,29.894a2.674,2.674,0,0,1,2.606-2.16h1.067A2.673,2.673,0,0,1,21.8,29.908a5.292,5.292,0,0,1-6.281-.014Zm3.139-3.227a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,18.656,26.667ZM24,25.6a5.307,5.307,0,0,1-1.315,3.5,3.779,3.779,0,0,0-2.127-2.166,2.667,2.667,0,1,0-3.8,0,3.777,3.777,0,0,0-2.121,2.149A5.331,5.331,0,1,1,24,25.6Zm-3.67-6.173a6.312,6.312,0,0,0-5.553,1.1l-2.1-2.309a6.354,6.354,0,0,0,1.4-6.353l5.866-2.486a6.435,6.435,0,0,0,2.992,2.829Zm0,0"
  //                   transform="translate(0)"
  //                   fill="#1a73e8"
  //                 />
  //               </svg>
  //             </div>
  //             <div className="px-2">
  //               <p className="m-0" style={{ wordBreak: "break-word" }}>
  //                 {item?.content}
  //               </p>
  //             </div>
  //           </div>
  //         );
  //       })}
  //       {/* <div
  //         className={`d-flex flex-row align-items-center py-3 ${styleEnd(
  //           "m",
  //           3,
  //           "md"
  //         )} sliderItem`}
  //         style={{
  //           border: "1px solid #1A73E8",
  //           borderRadius: 10,
  //           width: "35%",
  //           height: 100,
  //           overflow: "auto",
  //         }}
  //         onClick={(e) => {
  //           changeElementActiveClass(e);
  //           // dispatch(currentCommunity(6));
  //         }}
  //       >
  //         <div className="px-2">
  //           <svg
  //             xmlns="http://www.w3.org/2000/svg"
  //             width="32"
  //             height="32"
  //             viewBox="0 0 32 32"
  //           >
  //             <path
  //               id="networking_1_"
  //               data-name="networking (1)"
  //               d="M25.6,12.8a6.4,6.4,0,1,0-5.793-9.1l-1.714-.633a2.589,2.589,0,0,0,.041-.4,2.69,2.69,0,1,0-.408,1.4l1.711.632a6.283,6.283,0,0,0,.087,3.7l-5.866,2.486a6.369,6.369,0,0,0-7.915-3l-1.475-3.1a2.653,2.653,0,1,0-1.6.549,2.622,2.622,0,0,0,.641-.087l1.473,3.1A6.389,6.389,0,0,0,4.44,19.181l-.976,1.754a2.639,2.639,0,0,0-.8-.135,2.7,2.7,0,1,0,1.73.654L5.374,19.7a6.346,6.346,0,0,0,6.515-.759l2.1,2.309A6.369,6.369,0,0,0,12.267,25.6a6.441,6.441,0,0,0,.079.957l-2.47.586a2.651,2.651,0,1,0,.257,1.123c0-.029-.008-.057-.009-.086L12.59,27.6A6.4,6.4,0,1,0,24.3,22.574l3.133-2.037a2.719,2.719,0,1,0-.579-.9l-3.14,2.041a6.436,6.436,0,0,0-2.384-1.893l2.6-7.216A6.377,6.377,0,0,0,25.6,12.8ZM15.467,4.267a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,15.467,4.267Zm-14.4-1.6a1.6,1.6,0,1,1,1.6,1.6A1.6,1.6,0,0,1,1.067,2.667Zm1.6,22.4a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,2.667,25.067Zm4.8,4.8a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,7.467,29.867Zm21.867-12.8a1.6,1.6,0,1,1-1.6,1.6A1.6,1.6,0,0,1,29.333,17.067ZM22.459,10.7a2.674,2.674,0,0,1,2.608-2.167h1.067A2.674,2.674,0,0,1,28.741,10.7a5.293,5.293,0,0,1-6.282,0ZM25.6,7.467a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,25.6,7.467Zm0-6.4a5.325,5.325,0,0,1,4.026,8.821A3.778,3.778,0,0,0,27.5,7.73a2.667,2.667,0,1,0-3.8,0,3.778,3.778,0,0,0-2.124,2.157A5.325,5.325,0,0,1,25.6,1.067ZM2.667,13.867a5.333,5.333,0,1,1,9.352,3.5A3.779,3.779,0,0,0,9.892,15.2a2.667,2.667,0,1,0-3.8,0,3.777,3.777,0,0,0-2.121,2.149A5.3,5.3,0,0,1,2.667,13.867Zm3.723-.533a1.6,1.6,0,1,1,1.6,1.6A1.6,1.6,0,0,1,6.389,13.333ZM4.85,18.16A2.674,2.674,0,0,1,7.456,16H8.523a2.673,2.673,0,0,1,2.609,2.174A5.292,5.292,0,0,1,4.85,18.16ZM15.517,29.894a2.674,2.674,0,0,1,2.606-2.16h1.067A2.673,2.673,0,0,1,21.8,29.908a5.292,5.292,0,0,1-6.281-.014Zm3.139-3.227a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,18.656,26.667ZM24,25.6a5.307,5.307,0,0,1-1.315,3.5,3.779,3.779,0,0,0-2.127-2.166,2.667,2.667,0,1,0-3.8,0,3.777,3.777,0,0,0-2.121,2.149A5.331,5.331,0,1,1,24,25.6Zm-3.67-6.173a6.312,6.312,0,0,0-5.553,1.1l-2.1-2.309a6.354,6.354,0,0,0,1.4-6.353l5.866-2.486a6.435,6.435,0,0,0,2.992,2.829Zm0,0"
  //               transform="translate(0)"
  //               fill="#1a73e8"
  //             />
  //           </svg>
  //         </div>
  //         <div className="px-2">
  //           <p className="m-0" style={{ wordBreak: "break-word" }}>
  //             {slides[currentPage + 1].content}
  //           </p>
  //         </div>
  //       </div> */}
  //       <div
  //         style={{
  //           backgroundColor: "#1A73E8",
  //           height: 100,
  //           width: 100,
  //           cursor: "pointer",
  //           borderRadius: 10,
  //         }}
  //         className="d-flex flex-column justify-content-center text-center align-items-center itemNav"
  //       >
  //         <svg
  //           xmlns="http://www.w3.org/2000/svg"
  //           width="50"
  //           height="50"
  //           viewBox="0 0 16 16"
  //         >
  //           <path
  //             id="ic_zoom_in_24px"
  //             d="M14.435,13.063h-.723l-.256-.247a5.955,5.955,0,1,0-.64.64l.247.256v.723L17.637,19,19,17.637Zm-5.489,0a4.117,4.117,0,1,1,4.117-4.117A4.111,4.111,0,0,1,8.946,13.063Z"
  //             transform="translate(-3 -3)"
  //             fill="white"
  //           />
  //         </svg>
  //         <p className="text-white m-0">عرض الكل</p>
  //       </div>
  //     </div>
  //     <div
  //       className={`d-md-flex d-none justify-content-center align-items-center pb-3 ${
  //         getDir(getCurrentLangFromRedux()) === "rtl" ? "flex-row" : "flex-row-reverse"
  //       }`}
  //     >
  //       <div
  //         style={{
  //           backgroundColor: "#E5F0FE",
  //           height: 28,
  //           width: 28,
  //           cursor: "pointer",
  //           borderRadius: "50%",
  //         }}
  //         className="d-flex justify-content-center text-center align-items-center itemNav"
  //         onClick={(e) => {
  //           onRightClickHandler(e);
  //         }}
  //       >
  //         <Icon
  //           size={22}
  //           color="#246DDB"
  //           name="caret-right"
  //           className="icon"
  //           style={{ display: "block" }}
  //         />
  //       </div>
  //       <p className="m-0 px-2">{currentPage + 1}</p>
  //       <div
  //         style={{
  //           backgroundColor: "#E5F0FE",
  //           height: 28,
  //           width: 28,
  //           cursor: "pointer",
  //           borderRadius: "50%",
  //         }}
  //         className="d-flex justify-content-center text-center align-items-center itemNav"
  //         onClick={(e) => {
  //           onLeftClickHandler(e);
  //         }}
  //       >
  //         <Icon
  //           size={22}
  //           color="#246DDB"
  //           name="caret-left"
  //           className="icon"
  //           style={{ display: "block" }}
  //         />
  //       </div>
  //     </div>
  //     {/* small to mid screens */}
  //     <div className="d-flex d-md-none pt-2 pb-3">
  //       <div
  //         className="d-flex align-items-center mx-3 py-3"
  //         style={{
  //           border: "1px solid #1A73E8",
  //           borderRadius: 10,
  //           opacity: 1,
  //           width: "65%",
  //           height: 100,
  //           overflow: "auto",
  //         }}
  //       >
  //         <div className="px-2">
  //           <svg
  //             xmlns="http://www.w3.org/2000/svg"
  //             width="32"
  //             height="32"
  //             viewBox="0 0 32 32"
  //           >
  //             <path
  //               id="networking_1_"
  //               data-name="networking (1)"
  //               d="M25.6,12.8a6.4,6.4,0,1,0-5.793-9.1l-1.714-.633a2.589,2.589,0,0,0,.041-.4,2.69,2.69,0,1,0-.408,1.4l1.711.632a6.283,6.283,0,0,0,.087,3.7l-5.866,2.486a6.369,6.369,0,0,0-7.915-3l-1.475-3.1a2.653,2.653,0,1,0-1.6.549,2.622,2.622,0,0,0,.641-.087l1.473,3.1A6.389,6.389,0,0,0,4.44,19.181l-.976,1.754a2.639,2.639,0,0,0-.8-.135,2.7,2.7,0,1,0,1.73.654L5.374,19.7a6.346,6.346,0,0,0,6.515-.759l2.1,2.309A6.369,6.369,0,0,0,12.267,25.6a6.441,6.441,0,0,0,.079.957l-2.47.586a2.651,2.651,0,1,0,.257,1.123c0-.029-.008-.057-.009-.086L12.59,27.6A6.4,6.4,0,1,0,24.3,22.574l3.133-2.037a2.719,2.719,0,1,0-.579-.9l-3.14,2.041a6.436,6.436,0,0,0-2.384-1.893l2.6-7.216A6.377,6.377,0,0,0,25.6,12.8ZM15.467,4.267a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,15.467,4.267Zm-14.4-1.6a1.6,1.6,0,1,1,1.6,1.6A1.6,1.6,0,0,1,1.067,2.667Zm1.6,22.4a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,2.667,25.067Zm4.8,4.8a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,7.467,29.867Zm21.867-12.8a1.6,1.6,0,1,1-1.6,1.6A1.6,1.6,0,0,1,29.333,17.067ZM22.459,10.7a2.674,2.674,0,0,1,2.608-2.167h1.067A2.674,2.674,0,0,1,28.741,10.7a5.293,5.293,0,0,1-6.282,0ZM25.6,7.467a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,25.6,7.467Zm0-6.4a5.325,5.325,0,0,1,4.026,8.821A3.778,3.778,0,0,0,27.5,7.73a2.667,2.667,0,1,0-3.8,0,3.778,3.778,0,0,0-2.124,2.157A5.325,5.325,0,0,1,25.6,1.067ZM2.667,13.867a5.333,5.333,0,1,1,9.352,3.5A3.779,3.779,0,0,0,9.892,15.2a2.667,2.667,0,1,0-3.8,0,3.777,3.777,0,0,0-2.121,2.149A5.3,5.3,0,0,1,2.667,13.867Zm3.723-.533a1.6,1.6,0,1,1,1.6,1.6A1.6,1.6,0,0,1,6.389,13.333ZM4.85,18.16A2.674,2.674,0,0,1,7.456,16H8.523a2.673,2.673,0,0,1,2.609,2.174A5.292,5.292,0,0,1,4.85,18.16ZM15.517,29.894a2.674,2.674,0,0,1,2.606-2.16h1.067A2.673,2.673,0,0,1,21.8,29.908a5.292,5.292,0,0,1-6.281-.014Zm3.139-3.227a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,18.656,26.667ZM24,25.6a5.307,5.307,0,0,1-1.315,3.5,3.779,3.779,0,0,0-2.127-2.166,2.667,2.667,0,1,0-3.8,0,3.777,3.777,0,0,0-2.121,2.149A5.331,5.331,0,1,1,24,25.6Zm-3.67-6.173a6.312,6.312,0,0,0-5.553,1.1l-2.1-2.309a6.354,6.354,0,0,0,1.4-6.353l5.866-2.486a6.435,6.435,0,0,0,2.992,2.829Zm0,0"
  //               transform="translate(0)"
  //               fill="#1a73e8"
  //             />
  //           </svg>
  //         </div>
  //         <div className="px-2">
  //           <p className="m-0" style={{ wordBreak: "break-word" }}>
  //             {slides[currentPage].content}
  //           </p>
  //         </div>
  //       </div>
  //       <div
  //         style={{
  //           backgroundColor: "#1A73E8",
  //           height: 100,
  //           width: 100,
  //           cursor: "pointer",
  //           borderRadius: 10,
  //         }}
  //         className={`d-flex flex-column justify-content-center text-center align-items-center itemNav ${styleEnd(
  //           "m",
  //           2
  //         )}`}
  //       >
  //         <svg
  //           xmlns="http://www.w3.org/2000/svg"
  //           width="50"
  //           height="50"
  //           viewBox="0 0 16 16"
  //         >
  //           <path
  //             id="ic_zoom_in_24px"
  //             d="M14.435,13.063h-.723l-.256-.247a5.955,5.955,0,1,0-.64.64l.247.256v.723L17.637,19,19,17.637Zm-5.489,0a4.117,4.117,0,1,1,4.117-4.117A4.111,4.111,0,0,1,8.946,13.063Z"
  //             transform="translate(-3 -3)"
  //             fill="white"
  //           />
  //         </svg>
  //         <p className="text-white m-0">عرض الكل</p>
  //       </div>
  //     </div>
  //     <div
  //       className={`d-flex d-md-none justify-content-center align-items-center pb-3 ${
  //         getDir(getCurrentLangFromRedux()) === "rtl" ? "flex-row" : "flex-row-reverse"
  //       }`}
  //     >
  //       <div
  //         style={{
  //           backgroundColor: "#E5F0FE",
  //           height: 28,
  //           width: 28,
  //           cursor: "pointer",
  //           borderRadius: "50%",
  //         }}
  //         className="d-flex justify-content-center text-center align-items-center itemNav"
  //         onClick={(e) => {
  //           onSmallRightClickHandler(e);
  //         }}
  //       >
  //         <Icon
  //           size={22}
  //           color="#246DDB"
  //           name="caret-right"
  //           className="icon"
  //           style={{ display: "block" }}
  //         />
  //       </div>
  //       <p className="m-0 px-2">{currentPage + 1}</p>
  //       <div
  //         style={{
  //           backgroundColor: "#E5F0FE",
  //           height: 28,
  //           width: 28,
  //           cursor: "pointer",
  //           borderRadius: "50%",
  //         }}
  //         className="d-flex justify-content-center text-center align-items-center itemNav"
  //         onClick={(e) => {
  //           onSmallLeftClickHandler(e);
  //         }}
  //       >
  //         <Icon
  //           size={22}
  //           color="#246DDB"
  //           name="caret-left"
  //           className="icon"
  //           style={{ display: "block" }}
  //         />
  //       </div>
  //     </div>
  //   </>
  // );
  // else return <>'loading'</>;
};

export default Dashboard;
